import { API } from "aws-amplify";

const index = async (params) => {
  let myInit = {
    // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: params,
  };
  let items = await API.get(
    "InasakuAPI",
    "/inasaku/paddy-field-histories",
    myInit
  );

  return items;
};

export default {
  index: index,
};
